export const useScrollLock = () => {

  const lockScroll = () => {
    document.body.style.overflowY = "hidden";
  };

  const unlockScroll = () => {
    document.body.style.overflowY = "";
  };

  return {
    lockScroll,
    unlockScroll,
  };
};
